<template>
  <div class="news">
    <banner title="产品中心" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <!-- <div class="content-nav"> -->
        <!-- <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 1}"
            @click="newstype = 1"
          >
            <span>公司新闻</span>
          </div>
          <div
            class="content-nav-btn"
            :class="{'content-nav-active':newstype == 2}"
            @click="newstype = 2 "
          >
            <span>行业动态</span>
          </div> -->
        <!-- </div> -->

        <div class="content-nav-item">
          <div class="item-list" v-for="(item,index) in newsList" :key="index">
            <div class="item-img" v-lazy:background-image="item.Img"></div>
            <!-- <div class="item-img" v-lazy:background-image="imgserver + item.Img"></div> -->
            <p class="item-list-title">{{item.Title}}</p>
            <p class="item-list-content">{{item.Content}}</p>
            <div class="item-list-more">
              <router-link class="text-decoration" :to="{ name: 'newsdetails', params: { id: item.Id }}">
                <img src="../assets/img/sanjiao.png" />
                <span>more</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: {
    Banner,
  },
  data() {
    return {
      loading: true,
      newsList: [
        {
          Id: 28,
          Title: "PFC内膜灌注",
          Img: "https://qny.gaiamed360.com/%E9%A6%96%E9%A1%B5%E8%BD%AE%E6%92%AD%E5%9B%BE/1.png",
          Type: 1,
          Content:
            "PFC是冻干保存的血小板来源各种生长因子浓缩液的意思，PFC采用特殊方法浓缩激活和分离血液中的EGF、IL8、PDGF、TGFβ1、TSP1、VEGF、GM-CSF、FGF等因子及蛋白，再进行冻干等系列的标准化制备过程。是血小板被激活后释放的复合“生长因子”进一步提高体的“治愈力”的新治疗方法",
          CreateTime: "2023-11-29T11:35:37.38",
        },
        {
          Id: 28,
          Title: "金美韵",
          Img: "https://qny.gaiamed360.com/%E9%A6%96%E9%A1%B5%E8%BD%AE%E6%92%AD%E5%9B%BE/%E9%87%91%E7%BE%8E%E5%AD%95banner.jpg",
          Type: 1,
          Content:
            "金美韵主要原料采用进口虾青素协同姜黄素，提升女性生殖机能，尤其是对氧化应激反应造成的，像继发性卵巢早衰、多囊卵巢、卵巢功能低下有很好的体验，对更年期女性抗氧化的日常保养也有不错的反馈，同时可有效提升卵巢储备功能和试管助孕人群的成囊率，对妊娠率以及活产率有较好的营养补充体验",
          CreateTime: "2023-11-29T11:35:37.38",
        },
        {
          Id: 28,
          Title: "其他需求",
          Img: "https://qny.gaiamed360.com/%E9%A6%96%E9%A1%B5%E8%BD%AE%E6%92%AD%E5%9B%BE/2.png",
          Type: 1,
          Content:
            "试管的成功率受到多种因素影响，其中部分因素如胚胎质量、子宫内膜环境、内分泌与免疫状态是可以通过医疗手段和生活习惯的调整来改善的。 其中生活方式、饮食习惯可以通过个人努力直接改变。医疗手段的改善则需要专业医疗团队的支持，如采用高质量的医疗设备、改进胚胎培养条件、个体化的治疗方案等",
          CreateTime: "2023-11-29T11:35:37.38",
        }
      ],
      newstype: 1,
    };
  },
  methods: {
    loadData() {
      this.loading = true;
      this.$http
        .get(`News?type=${this.newstype}&num=6`)
        .then((response) => {
          //console.log(response);
          // this.newsList = response.data;
          this.loading = false;
          //window.console.log(this.newsList);
        })
        .catch(function (error) {
          window.console.log(error);
        });
    },
  },
  mounted() {
    this.loadData();
    this.loading  = false;//zhy
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.news {
  width: 100%;
  height: 100%;
  background-color: #14679f;
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid red;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;

        &-btn {
          width: 50%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 210px;
            background-color: #cecece;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            background-origin: content-box;
          }

          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 92px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>